import { render, staticRenderFns } from "./ObrasLista.vue?vue&type=template&id=76a6eee6&scoped=true"
import script from "./ObrasLista.vue?vue&type=script&lang=js"
export * from "./ObrasLista.vue?vue&type=script&lang=js"
import style0 from "./ObrasLista.vue?vue&type=style&index=0&id=76a6eee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a6eee6",
  null
  
)

export default component.exports